import React from "react";

export default function ContactUs() {
  return (
    <div style={{ maxWidth: "900px", margin: "40px auto", padding: "20px" }}>
      <h1>Contact Us</h1>

      <p>
        We'd love to hear from you. If you have any questions, feedback, or need
        support, please contact us using the details below.
      </p>

      <h2>Customer Support</h2>
      <p><strong>Email:</strong> support@kaamhub.in</p>
      <p><strong>Phone:</strong> +91 8657448453</p>

      <h2>Office Address</h2>
      <p>
        KaamHub<br />
        Mumbai, Maharashtra, India
      </p>

      <h2>Business Hours</h2>
      <p>
        Monday – Sunday<br />
        10:00 AM – 06:00 PM
      </p>

      <h2>Support</h2>
      <p>
        For booking issues, payment queries, refunds, or partner support,
        please contact us by email or phone.
      </p>

      <p><strong>Last Updated:</strong> July 2026</p>
    </div>
  );
}
